
import * as _ from "lodash"
import Vue from "vue"
import Component from "vue-class-component"
import {
  Dimension,
  Measure,
  MemberSnapshotCube,
  Metric,
  SuperScoreCube,
} from "@/cube"
import AnalyticsWidget from "@/superannuation/AnalyticsWidget.vue"
import PageHeader from "@/superannuation/PageHeader.vue"
import {Inject} from "vue-property-decorator"
import {DateRangeService} from "@/DateRangeService"
import {PlanService} from "@/superannuation/PlanService"
import BuiltWithAmcharts from "@/BuiltWithAmcharts.vue"

@Component({
  components: {BuiltWithAmcharts, AnalyticsWidget, PageHeader},
})
export default class AnalyticsView extends Vue {
  @Inject()
  planService: PlanService

  @Inject()
  dateRangeService: DateRangeService

  measure: Metric = <any>null

  dimensions: Array<Dimension> = <any>null

  $refs: {
    // Workaround - Inferred type is Vue instead of AnalyticsWidget
    analyticsWidget: AnalyticsWidget & {select: any}
  }

  pageReady = true

  created() {
    this.$watch(
      () => this.planService.current,
      async plan => {
        this.pageReady = false
        if (plan != null) {
          await this.dateRangeService.setPlan(plan.id)
          this.pageReady = true
        }
      }
    )
    console.log("this.$route.query.dimensions", this.$route.query.dimensions)
    this.measure =
      <Metric | null>this.$route.params.metric ??
      SuperScoreCube.averageSuperScore

    this.dimensions = _.castArray(
      <Array<Dimension> | null>this.$route.query.dimensions ?? [
        MemberSnapshotCube.ageGroup,
      ]
    )
  }

  select(measure: Measure, dimensions: Array<Dimension> = []) {
    this.$el.scrollIntoView({
      behavior: "smooth",
    })

    setTimeout(() => {
      this.$refs.analyticsWidget.select(measure, dimensions)
    }, 350)
  }
}
